import { useEffect, useState } from 'react'
import { useToast } from '../../../hooks/toast'
import * as Yup from 'yup'

import TextField from '../../TextField'
import Loader from '../../Loader'
import { FormGroup } from '../../Form/styles'
import * as S from './styles'
import Select from '../../Select'
import {
  formatCardNumber,
  getCardFlag,
  validateCard,
  validateCVV
} from '../../../utils/creditCardValidation'
import { months, monthsList, yearsList } from './cardDate'

import { adicionarCartao } from './fetch'
import { useDispatch, useSelector } from 'react-redux'
import pagamento from '../../../api/pagamento'
import { capitalizeWord, onlyNumber } from '../../../utils/utils'
import { converterNegociacaoCartao } from '../../../pages/Negociacoes/fetch'
import { useHistory } from 'react-router-dom'
import { sendToConverterCheckout } from '../../../utils/rotaConverter'
import ReCAPTCHA from 'react-google-recaptcha'

const FormAddNewCreditCard = ({
  type,
  tipo,
  cancelar,
  setPaymentModal,
  current,
  setCurrent,
  pedido,
  setLoader,
  setEsgotadoMessage
}) => {
  const dispatch = useDispatch()
  const store = useSelector((store) => store)
  const { addToast } = useToast()
  const history = useHistory()

  const [saveCard, setSaveCard] = useState(false)
  const [values, setValues] = useState({
    cardNumber: '',
    cardName: '',
    cardMonth: '',
    cardYear: '',
    cardCvv: ''
  })

  const [load, setLoad] = useState(false)
  const [inputErrors, setInputErrors] = useState(false)
  const [isCardNumberValid, setIsCardNumberValid] = useState(true)
  const [isCVVNumberValid, setIsCVVNumberValid] = useState(true)
  const [cardFlag, setCardFlag] = useState(null)

  const [captcha, setCaptcha] = useState({
    value: '',
    expired: false
  })

  const onCaptchaChange = (value) => {
    // console.log('Captcha:', value)

    if (value === null) {
      setCaptcha({
        value: value,
        expired: true
      })
    } else {
      setCaptcha({ value: value, expired: false })
    }
  }

  const onBlurCardNumberChange = () => {
    //Validação e Mensagem de erro ao sair input
    if (values.cardNumber.length > 0)
      validateCard(values.cardNumber)
        ? setIsCardNumberValid(true)
        : setIsCardNumberValid(false)
  }

  const maxLengthCardNumber = () => {
    if (cardFlag === 'amex') return 17
    else if (cardFlag === 'diners_club') return 16
    else return 19
  }

  const handleNameChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: value.replace(/[^a-zA-Z\s]/g, '') // apenas letras
      // [name]: value.replace(/[^a-zA-ZÀ-ú]/g, '')     permitindo acentos
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleNumberChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: formatCardNumber(value.replace(/\s+/g, ''))
    })

    //Validação e Mensagem de erro ao digitar
    // if (values.cardNumber.length > 14)
    //   validateCard(value)
    //     ? setIsCardNumberValid(true)
    //     : setIsCardNumberValid(false)

    setCardFlag(getCardFlag(value))

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleCVVChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: onlyNumber(value)
    })

    if (values.cardCvv.length > 0) {
      validateCVV(value, cardFlag)
        ? setIsCVVNumberValid(true)
        : setIsCVVNumberValid(false)
    }

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleSaveCard = () => {
    setSaveCard((prev) => !prev)
  }

  const adicionarCartao = async (body, setLoad) => {
    let newBody = {
      NomeTitular: body.cardName,
      NumeroCartao: body.cardNumber,
      CodigoSeguranca: body.cardCvv,
      ValidadeMes: +body.cardMonth,
      ValidadeAno: +body.cardYear,
      Bandeira: capitalizeWord(cardFlag),
      TokenCaptcha: captcha.value
    }

    setLoad(true)

    const response = await pagamento.addCartao(newBody)

    if (response.status >= 200 && response.status < 300) {
      addToast({
        type: 'success',
        title: 'Cartão adicionado'
      })
      type !== 'insideModal' && setCurrent(3)
    } else {
      addToast({
        type: 'error',
        title: 'Problema ao adicionar o cartão',
        description: `${response.data}`
      })
    }

    setLoad(false)
  }

  const anoAtual = new Date().getFullYear()

  useEffect(() => {
    values.cardYear == anoAtual &&
      setValues({
        ...values,
        cardMonth: monthsList(values.cardYear)[1].value
      })
  }, [values.cardYear])

  Yup.addMethod(Yup.string, 'creditCardFlag', function (errorMessage) {
    return this.test(`card-flag`, errorMessage, function () {
      const { path, createError } = this

      return (
        cardFlag !== undefined || createError({ path, message: errorMessage })
      )
    })
  })

  Yup.addMethod(Yup.string, 'creditCardNumber', function (errorMessage) {
    return this.test(`card-number`, errorMessage, function () {
      const { path, createError } = this

      return (
        isCardNumberValid === true ||
        createError({ path, message: errorMessage })
      )
    })
  })

  Yup.addMethod(Yup.string, 'creditCardCVV', function (errorMessage) {
    return this.test(`card-cvv`, errorMessage, function () {
      const { path, createError } = this

      return (
        isCVVNumberValid === true ||
        createError({ path, message: errorMessage })
      )
    })
  })

  const formData = {
    cardNumber: values.cardNumber,
    cardName: values.cardName,
    cardMonth: values.cardMonth,
    cardYear: values.cardYear,
    cardCvv: values.cardCvv,
    bandeira: capitalizeWord(cardFlag),
    tokenCaptcha: captcha.value
  }

  const passSchema = Yup.object().shape({
    cardNumber: Yup.string()
      .creditCardNumber('Número Inválido')
      .creditCardFlag('Bandeira não suportada')
      .required('Campo obrigatório*'),
    cardName: Yup.string().required('Campo obrigatório*'),
    cardMonth: Yup.string().required('Campo obrigatório*'),
    cardYear: Yup.string().required('Campo obrigatório*'),
    cardCvv: Yup.string()
      .creditCardCVV('CVV Inválido')
      .required('Campo obrigatório*')
  })

  const handleSubmit = async (event) => {
    event.preventDefault()
    // setLoad(false)
    try {
      setLoad(true)
      await passSchema.validate(formData, {
        abortEarly: false
      })

      if (captcha.value === '') {
        addToast({
          type: 'error',
          title: 'Por favor, complete a verificação "Não sou um Robô"'
        })
        setLoad(false)
      } else if (captcha.expired === true) {
        addToast({
          type: 'error',
          title:
            'Verificação expirada. Por favor, marque novamente a caixa de seleção'
        })
        setLoad(false)
      } else if (
        !!isCVVNumberValid &&
        !!isCardNumberValid &&
        type === 'insideModal'
      ) {
        // setDispatch()
        // console.log('Finalizar Cotação/Negociação com cartão novo')
        // console.log(formData)
        // console.log(pedido)
        let res = await converterNegociacaoCartao(
          pedido,
          formData,
          tipo,
          cardFlag
        )

        try {
          if (res?.includes('Convertido')) {
            !!saveCard &&
              adicionarCartao(
                { ...values, Bandeira: capitalizeWord(cardFlag) },
                setLoad
              )

            // history.push('/finalizado', {
            //   idPedido: res,
            //   type: 'cartao'
            // })

            sendToConverterCheckout(res, 'cartao')
          } else if (res?.includes('esgotou')) {
            setEsgotadoMessage(res)
            setPaymentModal(2)
            setLoad(false)
            setLoader(false)
          } else {
            addToast({
              type: 'error',
              title: 'Problema ao gerar Pedido. Tente novamente',
              description: `${res}`
            })
            setLoad(false)
            setLoader(false)
          }
        } catch (error) {
          addToast({
            type: 'error',
            title: 'Problema ao gerar Pedido. Tente novamente',
            description: `${res.Message}`
          })
          setLoader(false)
          setLoad(false)
        }
      } else if (!!isCVVNumberValid && !!isCardNumberValid) {
        adicionarCartao(
          { ...values, Bandeira: capitalizeWord(cardFlag) },
          setLoad
        )
        // console.log('Values', values)
      }
    } catch (err) {
      if (err) setLoad(false)

      if (err instanceof Yup.ValidationError) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== ''
        )

        if (!emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })

          const errorArray = err.inner.map(({ path, message }) => {
            return {
              name: path,
              message: message
            }
          })

          const objeto = errorArray.reduce((acc, d) => {
            acc[d.name] = d.message

            return acc
          }, {})

          setInputErrors(objeto)
        } else {
          setLoad(false)
          err.inner.map((error) => {
            addToast({
              type: 'error',
              title: `${error.message}`
            })
          })
        }
      }
    }
  }

  return (
    <S.WrapperSmall>
      <h3>Adicionar Cartão</h3>
      <S.RegisterCard type={type}>
        {!!load && <Loader></Loader>}

        <form onSubmit={handleSubmit}>
          <FormGroup
            className="form-group required"
            onBlur={onBlurCardNumberChange}
          >
            <label htmlFor="cardNumber">Número do Cartão</label>

            <TextField
              name="cardNumber"
              value={values.cardNumber}
              placeholder="Número do Cartão"
              onChange={(e) => handleNumberChange(e)}
              error={
                !isCardNumberValid ? 'Número inválido' : inputErrors.cardNumber
              }
              image={<S.CardImage cartao={cardFlag} />}
              maxlength={maxLengthCardNumber()}
              autoFocus
            />
          </FormGroup>

          <FormGroup className="form-group required">
            <label htmlFor="cardName">Nome do Titular</label>

            <TextField
              maxlength={80}
              name="cardName"
              value={values.cardName}
              placeholder="Titular do Cartão"
              onChange={handleNameChange}
              error={inputErrors.cardName}
            />
          </FormGroup>

          <div className="inline card-info">
            <FormGroup className="form-group required">
              <label htmlFor="expireDate">Validade</label>

              <div className="card-info">
                <Select
                  required
                  error={inputErrors.cardMonth}
                  onInput={(e) => {
                    setValues({
                      ...values,
                      cardMonth: e
                    })

                    setInputErrors({
                      ...inputErrors,
                      cardMonth: ''
                    })
                  }}
                  options={monthsList(values.cardYear)}
                ></Select>
                <Select
                  required
                  error={inputErrors.cardYear}
                  onInput={(e) => {
                    setValues({
                      ...values,
                      cardYear: e
                    })

                    setInputErrors({
                      ...inputErrors,
                      cardYear: ''
                    })
                  }}
                  options={yearsList(10)}
                ></Select>
              </div>
            </FormGroup>

            <FormGroup className="form-group required">
              <label htmlFor="cardCvv">CVV</label>

              <div className="cvv">
                <TextField
                  maxlength={4}
                  name="cardCvv"
                  value={values.cardCvv}
                  placeholder="CVV"
                  onChange={handleCVVChange}
                  error={
                    !isCVVNumberValid ? 'CVV Inválido' : inputErrors.cardCvv
                  }
                  tooltip
                  tooltipText="Código de Segurança"
                />
              </div>
            </FormGroup>
          </div>
          <S.CaptchaContainer>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
              onChange={onCaptchaChange}
            ></ReCAPTCHA>
          </S.CaptchaContainer>
          {type === 'insideModal' && (
            <FormGroup style={{ marginBottom: 8, marginTop: '-8px' }}>
              <input
                type="checkbox"
                name="salvar"
                id="salvar"
                onClick={handleSaveCard}
                checked={!!saveCard ? true : false}
              />
              <label htmlFor="salvar">Salvar Cartão para compras futuras</label>
            </FormGroup>
          )}
        </form>
      </S.RegisterCard>

      {type === 'insideModal' ? (
        <S.ProfileBoxFooter>
          <S.Button
            type={type}
            onClick={(e) => {
              handleSubmit(e)
            }}
          >
            Finalizar Compra
          </S.Button>
        </S.ProfileBoxFooter>
      ) : (
        <S.ProfileBoxFooter>
          <S.Button
            onClick={(e) => {
              handleSubmit(e)
            }}
          >
            Salvar Cartão
          </S.Button>
          <S.Button
            className="button-outline"
            onClick={() => {
              if (type === 'insideModal') {
                setCurrent(0)
              } else {
                setCurrent(1)
              }
            }}
          >
            Cancelar
          </S.Button>
        </S.ProfileBoxFooter>
      )}
    </S.WrapperSmall>
  )
}

export default FormAddNewCreditCard
